import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ContentMessageType, IconName } from '@thiememeulenhoff/types';
import { tag, contentMessageStyles } from './content-message.styles';
import {
  contentMessageIcons,
  ContentMessageVariant,
} from './content-message.types';

@customElement(tag)
export class ContentMessageComponent extends TmElement {
  @property({ type: String, reflect: true })
  type: ContentMessageType = 'message';

  @property({ reflect: true })
  variant: ContentMessageVariant = 'default';

  @property({ type: String, reflect: true })
  header?: string = 'Bericht';

  @property({ type: String, reflect: true })
  icon?: IconName;

  @property({ type: String, reflect: true })
  timeInformation?: string = 'now';

  static override styles = contentMessageStyles;

  override render() {
    return html`
      <div class="header-container">${this.#iconTemplate()}</div>
      ${this.#timeInfo()}
      <div class="content-message"><slot></slot></div>
    `;
  }

  #timeInfo() {
    return html`<div class="time-information">
      ${this.timeInformation ?? this.timeInformation}
    </div>`;
  }

  #iconTemplate() {
    return html`<a-icon
        class="content-message-icon-${this.type}"
        name="${this.icon ?? contentMessageIcons[this.type]}"
      ></a-icon
      ><span class="header">${this.header ?? this.header}</span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-content-message': ContentMessageComponent;
  }
}
